// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"88d7acf0","583":"28a8ac79","983":"9b61129f"}[chunkId] + ".chunk.js";
};